import vm from '@/main'
import router from '@/router'
import axios from 'axios'
import { ElMessage as Message, ElLoading as Loading } from 'element-plus'
import { setToken, setRefreshToken, getToken, getRefreshToken, setTokenExpires } from '@/utils/auth'
// import store from '@/store'
import { Mutex } from 'async-mutex'
import dayjs from 'dayjs'
import {
  sendPv,
  sendCdnTime,
  getParams,
  sendCl,
  getFrom,
  sendPf,
  getDeviceId
} from '@/utils/logTrack'
import { getUUID } from '@/utils/common.js'
import { terminal, appVersion } from '@/utils/device-detection'

const mutex = new Mutex()
const routeNameList = [
  'Detail',
  'Prompt',
  'Agreement',
  'PrivacyPolicy',
  'OnlineAlbum', // PC画册中转，用于中转以唤起app或小程序的，一般是在移动端网页中跳转到的。
  'PrivacyPolicyAppAndroid',
  'PrivacyPolicyAppIos'
]
const url_prefix = process.env.VUE_APP_API_URL
const deviceId = getDeviceId()
// 请求map
const pendingMap = new Map()
// loading实例
const LoadingInstance = {
  _target: null,
  _count: 0
}

const whiteList = [
  '/user/imgCode',
  '/user/verify_imgCode',
  '/chatglm/model_version',
  '/user/checkphone',
  '/user/login',
  '/user/signup',
  'user/verify',
  'impove'
]

// 筛选白名单
const checkIsInWhiteList = value => {
  for (let i = 0; i < whiteList.length; i++) {
    if (value.indexOf(whiteList[i]) !== -1) {
      return true
    }
  }
  return false
}

// 跳转到login
const goToLogin = msg => {
  console.log('msg: ', msg)
  const value = router.currentRoute?.value
  /* window.VueInstance.$store.dispatch('Home/HandleLogOut') */
  // 如果是chatglm4的分享页面 不跳转登录页面
  if (value?.meta?.isGlmsShare && value?.query.share_conversation_id) {
    return false
  }
  const redirect = location.pathname + location.search
  vm.$store.dispatch('Home/HandleLogOut')
  if (redirect === '/main/alltoolsdetail') return
  vm.goToLogin(msg) // 跳转至login页面
}

export const RefreshToken = async () => {
  const name = router.currentRoute?.value?.name
  console.log('RefreshToken: ', name)
  // refreshToken为空 and 不是detial页面
  if (!getRefreshToken() && !(routeNameList.indexOf(name) > -1)) {
    goToLogin('RefreshToken')
  }
  if (!getRefreshToken()) {
    sendPv({
      md: 'home',
      ct: 'refresh_token_null'
    })
    return Promise.reject(false)
  }
  sendPv({
    md: 'home',
    ct: 'refresh_token'
  })
  return new Promise((resolve, reject) => {
    const refreshToken = getRefreshToken()
    axios
      .post(
        `${url_prefix}/user-api/user/refresh`,
        {},
        {
          headers: {
            Authorization: refreshToken
          }
        }
      )
      .then(res => {
        sendPv({
          md: 'home',
          ct: 'refresh_token_success',
          extra: refreshToken
        })
        const expiresH = dayjs().add(2, 'hour').format('YYYY-MM-DD HH:mm:ss')
        setToken(res.data.result.access_token)
        setRefreshToken(res.data.result.refresh_token)
        setTokenExpires(expiresH)
        resolve(true)
      })
      .catch(() => {
        sendPv({
          md: 'home',
          ct: 'refresh_token_fail',
          extra: refreshToken
        })
        resolve(false)
      })
  })
}

async function request(axiosConfig, insetCustomOptions, loadingOptions) {
  await mutex.waitForUnlock()
  let result = await queryWithSilentSilentSignin(axiosConfig, insetCustomOptions, loadingOptions)
  if (result.error && result.error.status === 401) {
    if (mutex.isLocked()) {
      await mutex.waitForUnlock()
      result = await queryWithSilentSilentSignin(axiosConfig, insetCustomOptions, loadingOptions)
    } else {
      const release = await mutex.acquire()
      try {
        if (await RefreshToken()) {
          result = await queryWithSilentSilentSignin(
            axiosConfig,
            insetCustomOptions,
            loadingOptions
          )
        } else {
          const name = router.currentRoute?.value?.name
          if (!(routeNameList.indexOf(name) > -1)) {
            goToLogin('request')
          }
        }
      } finally {
        release()
      }
    }
  }
  if (result.error && result.error.status === 401) {
    return Promise.reject({ error: { status: 401 } })
  }
  return result
}

export async function queryWithSilentSilentSignin(axiosConfig, insetCustomOptions, loadingOptions) {
  if (
    insetCustomOptions?.withToken !== false &&
    !insetCustomOptions?.useRefreshToken &&
    !getToken()
  ) {
    return Promise.resolve({ error: { status: 401 } })
  }
  const service = axios.create({
    baseURL: process.env.VUE_APP_API_PATH, // 设置统一的请求前缀
    timeout: 10000, // 设置统一的超时时长10s
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
      'App-Name': 'chatglm',
      'X-Device-Id': deviceId,
      Platform: terminal,
      Version: appVersion,
      'X-Request-Id': getUUID()
    }
  })

  // 自定义配置
  const customOptions = Object.assign(
    {
      repeatRequestCancel: true, // 是否开启取消重复请求，默认为 true
      useRefreshToken: false, // 是否开启携带RefreshToken，默认为 false
      errorMessageShow: true, // 是否开启接口错误信息展示，默认为true
      withToken: true, // 是否携带token，默认为true
      withHeadersFr: false, // 是否请求头部携带X-App-fr，怕影响太多接口，在此配置。默认为false
      loading: true // 是否开启loading层效果，默认为true
    },
    insetCustomOptions
  )
  // 请求拦截
  service.interceptors.request.use(
    config => {
      removePending(config)
      customOptions.repeatRequestCancel && addPending(config)
      // 创建loading实例
      if (customOptions.loading) {
        LoadingInstance._count++
        if (LoadingInstance._count === 1) {
          LoadingInstance._target = Loading.service(
            Object.assign(
              {
                lock: true,
                text: 'Loading...',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.6)'
              },
              loadingOptions
            )
          )
        }
      }
      // 自动携带token
      if (customOptions.withToken && typeof window !== 'undefined') {
        if (customOptions.useRefreshToken) {
          config.headers.Authorization = getRefreshToken()
          console.log('config.headers.Authorization--------', config.headers.Authorization)
        } else {
          config.headers.Authorization = getToken()
          // config.headers.Authorization = ''
        }
        // console.log('---发送带过去的token:---', config.headers.Authorization)
      }

      // 后端有些接口需要，如微信新用户登录。在接口把本地存储中chatglm-fr传给后端，让后端与前端埋点产生关联。
      if (customOptions.withHeadersFr) {
        config.headers['X-App-fr'] = getFrom()
      }
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )

  // 响应拦截
  service.interceptors.response.use(
    response => {
      sendCdnTime({
        name: response.config.url,
        status: 'success',
        eagleid: response.headers?.eagleid || ''
      })
      removePending(response.config)
      customOptions.loading && closeLoading(customOptions) // 关闭loading
      if (response.status === 200) {
        if (checkIsInWhiteList(response.config.url)) {
          return Promise.resolve(response.data)
        }
        if (response.data) {
          if (
            response.data.status === 0 ||
            response.data.code === 200 ||
            response.data.code === 0 ||
            response.data.message === 'success'
          ) {
            return Promise.resolve(response.data)
          } else {
            const msg = response.data.message || response.data.msg
            customOptions.errorMessageShow &&
              msg &&
              Message({
                type: 'error',
                message: msg,
                duration: 3000
              })
          }
        } else {
          Message({
            type: 'error',
            message: '接口返回值data为空！'
          })
        }
      }
      return Promise.reject(response)
    },
    error => {
      const errInfo = { ...error }
      sendCdnTime({
        name: error && error.config && error.config.url,
        status: 'error',
        eagleid: error.response?.headers?.eagleid || ''
      })
      if (axios.isCancel(error)) {
        sendPf({
          md: 'request',
          ct: 'http_cancel',
          ctvl: error?.message || 'nomessage'
        })
      } else {
        sendPf({
          md: 'request',
          ct: 'http_error',
          ctid: error?.response?.status || 'no',
          ctvl: error?.config?.url || 'nourl'
        })
      }
      error.config && removePending(error.config)
      customOptions.loading && closeLoading(customOptions) // 关闭loading
      customOptions.errorMessageShow && httpErrorStatusHandle(error) // 处理错误状态码

      if (error.response?.status === 401) {
        return Promise.resolve({ error: { status: 401 } })
      } else {
        return Promise.reject(errInfo) // 错误继续返回给到具体页面
      }
    }
  )

  return service(axiosConfig)
}

export default request

/**
 * 处理异常
 * @param {*} error
 */
function httpErrorStatusHandle(error) {
  // 处理被取消的请求
  if (axios.isCancel(error)) {
    return console.error('请求的重复请求：' + error?.statusText)
  }
  let message = ''
  if (error) {
    error = JSON.stringify(error)
    error = JSON.parse(error)
    switch (error.status) {
      case 302:
        message = '接口重定向了！'
        break
      case 400:
        message = '参数不正确！'
        break
      case 401:
        message = ''
        // goToLogin()
        break
      case 403:
        message = '您没有权限操作！'
        break
      case 404:
        message = `请求地址出错: ${error.response.config.url}`
        break // 在正确域名下
      case 408:
        message = '请求超时！'
        break
      case 409:
        message = '系统已存在相同数据！'
        break
      case 500:
        message = '服务器内部错误！'
        break
      case 501:
        message = '服务未实现！'
        break
      case 502:
        message = '网关错误！'
        break
      case 503:
        message = '服务不可用！'
        break
      case 504:
        message = '服务暂时无法访问，请稍后再试！'
        break
      case 505:
        message = 'HTTP版本不受支持！'
        break
      case 1:
        message = ''
        break
      default:
        message = '异常问题，请联系管理员！'
        break
    }
  }
  if (error.message.includes('timeout')) {
    message = '网络请求超时！'
    sendPv({
      md: 'request',
      ct: 'request_timeout',
      ctvl: error.config.url
    })
  }
  if (error.message.includes('Network')) {
    console.log(error.message, 'error.messageerror.message')
    sendPf({
      md: 'detail',
      ct: 'network_error',
      ctvl: error?.config?.url || 'nourl'
    })
    message = window.navigator.onLine ? '服务端异常！' : '当前无法连接服务器，请检查网络是否通畅！'
  }

  if (message && error.status !== 400) {
    Message({
      type: 'error',
      message
    })
  }
}

/**
 * 关闭Loading层实例
 * @param {*} _options
 */
function closeLoading(_options) {
  if (_options.loading && LoadingInstance._count > 0) LoadingInstance._count--
  if (LoadingInstance._count === 0) {
    LoadingInstance._target.close()
    LoadingInstance._target = null
  }
}

/**
 * 储存每个请求的唯一cancel回调, 以此为标识
 * @param {*} config
 */
function addPending(config) {
  const pendingKey = getPendingKey(config)
  config.cancelToken =
    config.cancelToken ||
    new axios.CancelToken(cancel => {
      if (!pendingMap.has(pendingKey)) {
        pendingMap.set(pendingKey, cancel)
      }
    })
}

/**
 * 删除重复的请求
 * @param {*} config
 */
function removePending(config) {
  const pendingKey = getPendingKey(config)
  if (pendingMap.has(pendingKey)) {
    const cancelToken = pendingMap.get(pendingKey)
    cancelToken(pendingKey)
    pendingMap.delete(pendingKey)
  }
}

/**
 * 生成唯一的每个请求的唯一key
 * @param {*} config
 * @returns
 */
function getPendingKey(config) {
  let { url, method, params, data } = config
  if (url !== '/paas/risk/checkV2') {
    if (typeof data === 'string') data = JSON.parse(data) // response里面返回的config.data是个字符串对象
    return [url, method, JSON.stringify(params), JSON.stringify(data)].join('&')
  }
}

// 处理简单请求
const simpleAxios = axios.create({
  baseURL: url_prefix, // 设置统一的请求前缀
  timeout: 10000, // 设置统一的超时时长10s
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})
function dealResult(data, resolve, reject) {
  const { status } = data.data || {}
  if (status === 0) {
    resolve(data.data || {})
  } else {
    reject(data.data || {})
  }
}
const simpleRequest = {
  get(url) {
    return new Promise((resolve, reject) => {
      simpleAxios
        .get(url)
        .then(data => {
          dealResult(data, resolve, reject)
        })
        .catch(() => {
          reject('网络错误，请重试')
        })
    })
  },
  post(url, params) {
    return new Promise((resolve, reject) => {
      simpleAxios
        .post(url, params)
        .then(data => {
          dealResult(data, resolve, reject)
        })
        .catch(() => {
          reject('网络错误')
        })
    })
  }
}

// https://modelnet.ai/api/community/sms/smsCode?phoneNumber=xxx
export function getCommunitySmsCode(params) {
  return simpleRequest.post(`/backend-api/v3/user/register_check_phone`, params)
}
// https://modelnet.ai/api/community/sms/checkSmsCode?phoneNumber=xxx&code=xx
export function checkCommunitySmsCode(params) {
  // 增加神策埋点参数
  params = Object.assign(params, getParams())
  return simpleRequest.post(`/backend-api/v3/user/register_application`, params)
}
// https://modelnet.ai/api/community/applyChatGlm/insert
export function submitCommunity(params) {
  return simpleRequest.post(`applyChatGlm/insert`, params)
}
